import { ThemeIconProps, ThemeIcon } from "@mantine/core"
import {
  IconCheck,
  IconFlagExclamation,
  IconSquare,
  IconX,
  IconPencilCheck,
} from "@tabler/icons-react"
import { match } from "ts-pattern"

export type ContractTrackingIconVariant =
  | "todo"
  | "deadline"
  | "done"
  | "default"
  | "deadline-todo"
  | "canceled"
  | "done-todo"

interface Props extends ThemeIconProps {
  variant: ContractTrackingIconVariant
}

const todoBorder = "solid var(--mantine-color-blue-5) 3px"

export const ContractTrackingIcon = React.forwardRef<HTMLDivElement, Props>(
  function ContractTrackingIcon({ variant, ...themeIconProps }, ref) {
    const iconProps = match(variant)
      .returnType<ThemeIconProps>()
      .with("done", () => ({
        color: "green",
        children: <IconCheck />,
      }))
      .with("done-todo", () => ({
        color: "green",
        children: <IconCheck />,
        bd: todoBorder,
      }))
      .with("todo", () => ({
        color: "blue",
        children: <IconPencilCheck />,
      }))
      .with("deadline", () => ({
        color: "yellow",
        children: <IconFlagExclamation />,
      }))
      .with("deadline-todo", () => ({
        color: "yellow",
        children: <IconFlagExclamation />,
        bd: todoBorder,
      }))
      .with("default", () => ({ variant: "default", children: <IconSquare /> }))
      .with("canceled", () => ({
        color: "gray",
        children: <IconX />,
      }))
      .exhaustive()

    return (
      <ThemeIcon
        ref={ref}
        variant="filled"
        bd="none"
        radius="xl"
        px={4}
        {...iconProps}
        {...themeIconProps}
      />
    )
  }
)
